'use client'

import ExternalLink from '@susu/headless-commerce/components/ExternalLink/ExternalLink'
import { useCountry } from '@susu/headless-commerce/contexts/country/client'
import { useLocale } from '@susu/headless-commerce/contexts/locale/client'
import { usePageType } from '@susu/headless-commerce/hooks/usePageType'
import { highlightText } from '@susu/headless-commerce/utils/highlightText'
import { useI18N } from '@susu/i18n/client'
import type { ClientNavContext } from '../ClientNavProvider'
import styles from './NavSearchResults.module.scss'
import { handleSearchResultClick } from './searchResultsTracking'

export type PopularSearchPhrasesProps = {
  inputValue: string
  popularSearchPhrasesQuery: ClientNavContext['popularSearchQuery']['value']
  searchPanelOpenedFrom: 'header' | 'menu'
}

export const ClientPopularSearchPhrases = ({
  inputValue,
  popularSearchPhrasesQuery,
  searchPanelOpenedFrom,
}: PopularSearchPhrasesProps) => {
  const { t } = useI18N()
  const suggestionsClass = styles['nav__search-suggestions']
  const locale = useLocale()
  const country = useCountry()
  const pageType = usePageType()

  return (
    <div className={suggestionsClass}>
      <span
        className={styles['nav__search-label']}
        data-testid="heading_search_popular-searches"
      >
        {t('navigation.popular_searches')}
      </span>
      <div className={styles['nav__search-items']}>
        {popularSearchPhrasesQuery.data?.getPopularSearchPhrases?.map(
          (suggestion: string, i: number) => {
            return (
              // biome-ignore lint/a11y/useKeyWithClickEvents:
              <div
                className={styles['nav__search-item']}
                key={`${suggestion}-${i + 1}`}
                onClick={() =>
                  handleSearchResultClick(
                    suggestion,
                    searchPanelOpenedFrom,
                    locale,
                    country,
                    pageType,
                  )
                }
              >
                <ExternalLink
                  className={styles['nav__search-link']}
                  href={`search?q=${suggestion}`}
                  automationId={`search-popular_${i + 1}`}
                >
                  {highlightText(suggestion, inputValue)}
                </ExternalLink>
              </div>
            )
          },
        )}
      </div>
    </div>
  )
}
